module.exports = __webpack_public_path__ + "img/helpdesk.b1113cea.jpg";